module.exports = __webpack_public_path__ + "img/ken_yes.4c0d8e93.png";